import React from 'react'
import classnames from 'classnames'

import Button from '../Button'

import './SaveButton.less'

const COMPONENT_CLASS = 'nmc-button-save'

export default class SaveButton extends React.Component {
  render () {
    const headerClass = classnames(COMPONENT_CLASS, this.props.className || [])
    return (
      <Button
        {...this.props}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
        className={headerClass}
      >
        {this.props.children || 'save'}
      </Button>
    )
  }
}

SaveButton.propTypes = Button.propTypes



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/SaveButton/index.js